import * as trace from 'owa-trace';

export default function traceAndReject(funcName: string, error: string) {
    const errorMessage = `[${funcName}]: ` + error;
    trace.errorThatWillCauseAlert(errorMessage);
    return Promise.reject(errorMessage);
}
